import React, { Component } from 'react'
import '../styles/PopInExpiration.css'
import PopIn from './PopIn'
import Ticket from '../images/Expiration/ticket.png'
import { injectIntl, defineMessages } from "react-intl"

const convertTime = (time) => {
  return Math.floor((time / 1000) / 60)
}

class PopInExpiration extends Component {

  render() {
    const {intl:{formatMessage}} = this.props
    return (
      <div className="popin-expiration">
        <PopIn
          closePopIn={() => this.props.closePopIn()}
        >
          <img alt="" src={Ticket} />
          <h3>{`${formatMessage(messages.title)} ${convertTime(this.props.timeLeft)} min`}</h3>
          <p>{formatMessage(messages.info)}</p>
          <div
            onClick={this.props.giveMeTime}
            className="popin-expiration-cta">{formatMessage(messages.cta)}</div>
        </PopIn>
      </div>
    )
  }
}

const messages = defineMessages({
  title: {
    id: 'popInExpiration.title',
    defaultMessage: 'Votre réservation expirera dans'
  },
  info: {
    id: 'popInExpiration.info',
    defaultMessage: 'Afin de nous permettre de gérer la disponibilité des places, les paniers expirent au bout de 5mn.'
  },
  cta: {
    id: 'popInExpiration.cta',
    defaultMessage: 'Donnez-moi encore un peu de temps !'
  }
})

export default injectIntl(PopInExpiration)



// WEBPACK FOOTER //
// ./src/components/PopInExpiration.js